import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

export interface DataInterface {
  isVisible: boolean;
  type: string;
}

@Injectable()
export class DetailedSearchService {

  _data = new Subject<DataInterface>();
  data: Observable<any>  = this._data.asObservable();

  update (data: DataInterface) {
    this._data.next({
      isVisible: data.isVisible,
      type:      data.type
    });
  }
}
